module.exports = __webpack_public_path__ + "static/afrika-414311af92fd7bc7c15b0a09cfd02ed3.svg";